<div class="main-container">
  <app-embedded-loader [show]="showLoader"></app-embedded-loader>
  <div class="title-text">Quotations</div>
  <div class="section" *ngIf="issupplier">
    <div class="search-filter-container">
      <div class="search-container">
        <mat-icon style="margin-left: 10px">search</mat-icon>
        <input
          type="text"
          [(ngModel)]="searchParam"
          placeholder="Search All Documents"
          class="search-input"
        />
        <button class="search-button" (click)="onSearch()">Search</button>
      </div>
      <div class="search-filter-content">
        <mat-form-field class="date-field" appearance="fill">
          <mat-label>From Date</mat-label>
          <input
            matInput
            [matDatepicker]="fromDatepicker"
            placeholder="DD/MM/YYYY"
            [(ngModel)]="fromDate"
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="fromDatepicker"
            [disabled]="false"
          ></mat-datepicker-toggle>
        </mat-form-field>
        <mat-datepicker #fromDatepicker></mat-datepicker>

        <mat-form-field class="date-field" appearance="fill">
          <mat-label>To Date</mat-label>
          <input
            matInput
            [matDatepicker]="toDatepicker"
            placeholder="DD/MM/YYYY"
            [(ngModel)]="toDate"
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="toDatepicker"
            [disabled]="false"
          ></mat-datepicker-toggle>
        </mat-form-field>
        <mat-datepicker #toDatepicker></mat-datepicker>
        <div class="search-filter-button-container">
          <button type="submit" class="search-btn" (click)="onSearch()">
            <mat-icon>search</mat-icon>
          </button>
          <button type="button" class="close-button" (click)="cancelFilter()">
            <mat-icon>cancel</mat-icon>
          </button>
        </div>
      </div>
    </div>

    <div class="filter-statuses">
      <button *ngFor="let status of filterStatuses; let i = index" class="status-btn"
        [ngClass]="{ active: activeIndex === i }" (click)="onStatusSelect(status.name, i, status.label)"
        matTooltip="{{ status.label }}">
        {{ status.name }}
      </button>
    
      <!-- More Button with Dropdown -->
      <div class="more-dropdown">
        <button class="status-btn more-btn" (click)="toggleDropdown()">
          More...
        </button>
        <div class="dropdown-menu" *ngIf="dropdownOpen">
          <button *ngFor="let extra of otherStatus; let j = index" class="dropdown-item"
            (click)="onStatusSelect(extra.name, filterStatuses.length + j, extra.label); toggleDropdown()"
            matTooltip="{{ extra.label }}">
            {{ extra.name }}
          </button>
        </div>
      </div>

      <!-- Quote Type Switcher Dropdown -->
      <div class="rfq-type-dropdown" style="margin-left: auto;">
        <button class="status-btn rfq-type-btn" [ngClass]="{ active: true }" (click)="toggleQuoteTypeDropdown()">
          Product Quotation <mat-icon style="font-size: 18px; height: 18px; width: 18px; vertical-align: middle;">arrow_drop_down</mat-icon>
        </button>
        <div class="dropdown-menu rfq-type-menu" *ngIf="quoteTypeDropdownOpen">
          <button class="dropdown-item active-item" (click)="toggleQuoteTypeDropdown()">
            Product Quotation
          </button>
          <button class="dropdown-item" (click)="navigateToQuoteType('service'); toggleQuoteTypeDropdown()">
            Service Quotation
          </button>
        </div>
      </div>
    </div>



    <!-- <div class="filter-section-up">
      <span class="filter-button" (click)="toggleVisibility()">
        <div
          style="
            display: inline-flex;
            align-items: center;
            position: relative;
            bottom: 5px;
          "
        >
          <mat-icon style="font-size: 20px">filter_alt</mat-icon>
          <span style="margin-left: 4px">Filters</span>
        </div>

        <mat-icon style="position: relative; bottom: 5px">
          {{ isFilterExpand ? "expand_less" : "expand_more" }}
        </mat-icon>
      </span>

      <div
        *ngIf="isFilterExpand"
        style="
          box-shadow: 0 0 3px 1px #0003, 0 2px 2px #00000024,
            0 1px 5px #0000001f;
          border-radius: 5px;
          min-height: 175px;margin-bottom: 20px;
        "
      >
        <div class="filter-content">
          <mat-form-field class="date-field" appearance="fill">
            <mat-label>From Date</mat-label>
            <input
              matInput
              [matDatepicker]="fromDatepicker"
              placeholder="DD/MM/YYYY"
              [(ngModel)]="fromDate"
            />
            <mat-datepicker-toggle
              matSuffix
              [for]="fromDatepicker"
              [disabled]="false"
            ></mat-datepicker-toggle>
          </mat-form-field>
          <mat-datepicker #fromDatepicker></mat-datepicker>

          <mat-form-field class="date-field" appearance="fill">
            <mat-label>To Date</mat-label>
            <input
              matInput
              [matDatepicker]="toDatepicker"
              placeholder="DD/MM/YYYY"
              [(ngModel)]="toDate"
            />
            <mat-datepicker-toggle
              matSuffix
              [for]="toDatepicker"
              [disabled]="false"
            ></mat-datepicker-toggle>
          </mat-form-field>
          <mat-datepicker #toDatepicker></mat-datepicker>
          <div class="filter-button-container">
            <button type="submit" class="search-btn" (click)="onSearch()">
              <mat-icon>search</mat-icon>
            </button>
            <button type="button" class="close-button" (click)="cancelFilter()">
              <mat-icon>cancel</mat-icon>
            </button>
          </div>
        </div>
        <div class="filter-container filter-statuses">
          <button
            *ngFor="let status of filterStatuses"
            class="status-btn"
            [ngClass]="{ active: selectedStatus === status }"
            (click)="onStatusSelect(status)"
          >
            {{ status }}
          </button>
        </div>
      </div>
    </div> -->

    <div
      class="filter-section"
      style="display: flex; align-items: center"
      *ngIf="this.selectedRfq.length > 0"
    >
      <div style="margin-left: 20px">
        <b
          >Selected {{ this.selectedRfq.length }} of
          {{ this.totalRecords }} Quotes</b
        >
      </div>

      <button
        style="position: relative; bottom: 3px"
        mat-icon-button
        mat-sm-button
        color="primary"
        class="mr-1"
        matTooltipClass="mat-tooltip-custom"
        matTooltip="Archive"
        matTooltipPosition="below"
        (click)="rfqOperation('archive')"
      >
        <mat-icon>archive</mat-icon>
      </button>
    </div>

    <div class="dropdown-container-active-table">
      <div class="text-right" style="display: inline-flex; align-items: center">
        <button
          mat-mini-fab
          (click)="exportAllQuotes()"
          matTooltip="Export All"
          matTooltipPosition="below"
        >
          <mat-icon
            matTooltipClass="mat-tooltip-custom"
            svgIcon="downloadExcel"
          ></mat-icon>
        </button>
        <!-- <span style="font-size: 16px;font-weight: bolder;margin-left:5px">Export All</span> -->
      </div>

      <div
        style="
          width: 7%;
          display: flex;
          justify-content: space-between;
          align-items: center;
        "
      >
        <div class="invitebutton-container">
          <!-- Button to trigger the user invite menu -->
          <button
            class="circle-button"
            [matMenuTriggerFor]="usermenu"
            matTooltip="Invite User"
            (click)="onUserMenuOpened()"
          >
            <mat-icon class="icon-person"> person_add </mat-icon>
          </button>

          <!-- Menu for inviting users with fixed height and scrollable -->
          <mat-menu #usermenu="matMenu" id="usermenu" >
            <!-- Menu content container with scroll event -->
            <div class="menu-content" (scroll)="onScroll()">
              <!-- User list displayed inside the menu with checkboxes for selection -->
              <button
                mat-menu-item
                *ngFor="let item of supplierUsersList"
                (click)="toggleUserSelection(item)"
              >
                <mat-checkbox [checked]="item.selected">{{
                  item.firstName
                }}</mat-checkbox>
              </button>

              <!-- Spinner or loading indicator when fetching more users -->
              <mat-progress-spinner
                *ngIf="isLoading"
                mode="indeterminate"
                diameter="20"
              ></mat-progress-spinner>
            </div>
          </mat-menu>
        </div>
        <div>
          <button
            mat-fab
            class="green-button"
            [matMenuTriggerFor]="menu"
            matTooltip="Show more columns"
          >
            <mat-icon style="position: relative; right: -3px"
              >playlist_add</mat-icon
            >
          </button>
          <mat-menu #menu="matMenu">
            <button
              mat-menu-item
              *ngFor="let item of items"
              (click)="toggleSelection(item)"
            >
              <mat-checkbox [checked]="item.selected">{{
                item.label
              }}</mat-checkbox>
            </button>
          </mat-menu>
        </div>
      </div>
    </div>

    <div class="active-table-container">
      <ngx-datatable
        style="border-radius: 5px"
        #supplierTable
        class="material expandable bg-light supplier-table sup-tbl"
        [rows]="documentData"
        [rowIdentity]="rowIdentity"
        [headerHeight]="50"
        [footerHeight]="50"
        [rowHeight]="'auto'"
        [columnMode]="'force'"
        [limit]="limit"
        [count]="totalRecords"
        [externalPaging]="true"
        [externalSorting]="true"
        [scrollbarH]="false"
        [offset]="offset"
        (page)="onPageChange($event)"
        (sort)="onSort($event)"
        [rowClass]="setRowClass"
      >
        <ngx-datatable-column name="Quote Reference" [flexGrow]="1">
          <ng-template let-row="row" ngx-datatable-cell-template>
            <span
              class="rfq-reference"
              matTooltip="{{ row.quoteRefNumber }}"
              matTooltipPosition="below"
              (click)="openQuoteDetails(row.rfqDetailsId, row.quoteId)"
              >{{ row.quoteRefNumber }}</span
            >
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="RFQ Reference" [flexGrow]="1">
          <ng-template let-row="row" ngx-datatable-cell-template>
            <span
              class="rfq-reference"
              matTooltip="{{ row.rfqRefNumber }}"
              matTooltipPosition="below"
              (click)="openRfqDetails(row.rfqDetailsId)"
              >{{ row.rfqRefNumber }}</span
            >
          </ng-template>
        </ngx-datatable-column>

        <!-- Port Name -->
        <ngx-datatable-column name="Port Name" [flexGrow]="1">
          <ng-template let-row="row" ngx-datatable-cell-template>
            <span
              class="Port Name"
              matTooltip="{{ row.portName }}"
              matTooltipPosition="below"
              >{{ row.portName }}</span
            >
          </ng-template>
        </ngx-datatable-column>

        <!-- Buyer with Logo -->
        <ngx-datatable-column name="Buyer" [flexGrow]="1">
          <ng-template let-row="row" ngx-datatable-cell-template>
            <div class="buyer-cell">
              <img [src]="row.organizationLogo" class="buyer-logo" alt="logo" />
              <span
                matTooltip="{{ row.companyName }}"
                matTooltipPosition="below"
                >{{ row.companyName }}</span
              >
            </div>
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="Owner" [flexGrow]="1">
          <ng-template let-row="row" ngx-datatable-cell-template>
            <span
              matTooltip="{{
                row.supplierUserName ? row.supplierUserName : row.supplierName
              }}"
              matTooltipPosition="below"
            >
              {{ row.supplierUserName || row.supplierName }}
            </span>
          </ng-template>
        </ngx-datatable-column>

        <!-- Status -->
        <ngx-datatable-column name="Status" [minWidth]="150" [flexGrow]="1">
          <ng-template let-row="row" ngx-datatable-cell-template>
            <span
              class="status-pill"
              matTooltip="{{ quoteStatuses[row.quoteStatus - 1] }}"
              matTooltipPosition="below"
              [ngStyle]="{
                color: getStatusColor(quoteStatuses[row.quoteStatus - 1])
              }"
            >
              {{ quoteStatuses[row.quoteStatus - 1] }}
            </span>
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="Quotation Submission Date" [flexGrow]="1">
          <ng-template let-row="row" ngx-datatable-cell-template>
            <span
              class="RFQ Date"
              matTooltip="{{ row.quotationDate | date : 'dd/MM/yyyy' }}"
              matTooltipPosition="below"
            >
              {{ formatRfqDate(row.quotationDate) }}
            </span>
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column
        name="ATT/Contact/Print/Download"
        [resizeable]="true"
        [sortable]="false"
        [flexGrow]="0"
        [minWidth]="260"
        [maxWidth]="300"
      >
        <ng-template let-row="row" ngx-datatable-cell-template>
          <div class="action-buttons-container">
            <button
              mat-icon-button
              color="primary"
              matTooltip="Attachments"
              matTooltipPosition="below"
              (click)="togglePreview(true, row)"
            >
              <mat-icon>attach_file</mat-icon>
            </button>
      
            <button
              mat-icon-button
              color="primary"
              matTooltip="Buyer contact Details"
              matTooltipPosition="below"
              (click)="toggleContactPopUp(true, row)"
            >
              <mat-icon>local_phone</mat-icon>
            </button>
            

            <span
            [matTooltip]="
              quoteStatuses[row.quoteStatus - 1] === 'Draft'
                ? 'Printing is disabled for Draft Quote.'
                : 'Print'
            "
            matTooltipPosition="below"
          >
            <button
              mat-icon-button
              color="primary"
              [disabled]="quoteStatuses[row.quoteStatus - 1] === 'Draft'"
              (click)="downloadQuote(row.quoteRefNumber, row)"
            >
              <mat-icon>print</mat-icon>
            </button>
          </span>


          <span
          [matTooltip]="
            quoteStatuses[row.quoteStatus - 1] === 'Draft'
              ? 'Download is disabled for Draft Quote.'
              : 'Download'
          "
          matTooltipPosition="below"
        >
          <button
            mat-icon-button
            color="primary"
            [disabled]="quoteStatuses[row.quoteStatus - 1] === 'Draft'"
            (click)="generateQuoteExcel(row.quoteId, row.rfqId, row.supplierId, row.quoteRefNumber)"
          >
            <mat-icon>download</mat-icon>
          </button>
        </span>
      
      
            
          </div>
        </ng-template>
      </ngx-datatable-column>

        <ngx-datatable-column
          *ngFor="let column of selectedColumns"
          [name]="column.label"
          [flexGrow]="1"
        >
          <ng-template let-row="row" ngx-datatable-cell-template>
            <span
              *ngIf="isDate(row[column.prop])"
              matTooltip="{{ row[column.prop] | date : 'dd/MM/yyyy' : '-' }}"
              matTooltipPosition="below"
            >
              {{ row[column.prop] | date : "dd/MM/yyyy" : "-" }}
            </span>
            <span
              *ngIf="!isDate(row[column.prop])"
              matTooltip="{{ row[column.prop] || '-' }}"
              matTooltipPosition="below"
            >
              {{ row[column.prop] || "-" }}
            </span>
          </ng-template>
        </ngx-datatable-column>

        <!-- Toggle Expand Button Column -->
        <ngx-datatable-column
          [sortable]="false"
          [maxWidth]="65"
          [minWidth]="65"
        >
          <ng-template let-row="row" ngx-datatable-cell-template>
            <mat-icon
              class="live-status-button"
              (click)="toggleExpandedRow(row)"
              matTooltip="Live status"
            >
              {{
                expandedQuoteId === row.quoteId ? "expand_less" : "expand_more"
              }}
            </mat-icon>
            <div
              *ngIf="expandedQuoteId === row.quoteId"
              style="height: 140px; width: 1px"
            ></div>
            <!-- Expanded Row for Status Tracker -->
            <div
              class="status-tracker-main-container"
              *ngIf="expandedQuoteId === row.quoteId"
            >
              <div class="expanded-status-row">
                <div class="status-timeline-container">
                  <!-- <div class="timeline-box-header">
                    <div
                      class="timeline-box-in"
                      *ngFor="let stage of row.statusesStages"
                    >
                      <div
                        class="timeline-stage-header"
                        
                      >
                        <div class="stage-header-up">
                          <span class="stage-heading">{{ stage.heading }}</span>
                          <span class="stage-date">{{ stage.date }}</span>
                        </div>
                      </div>
                    </div>
                    
                  </div> -->
                  <div class="timeline-box">
                    <div
                      class="timeline-box-in"
                      *ngFor="let stage of row.statusesStages"
                    >
                      <div class="timeline-stage">
                        <div class="stage-header">
                          <span class="stage-label">{{ stage.label }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="timeline-box-footer">
                    <div
                      class="timeline-box-in"
                      *ngFor="let stage of row.statusesStages; let i = index"
                    >
                      <div class="timeline-stage-footer">
                        <div
                          class="stage-point"
                          [ngClass]="[
                            getStageColorClass(stage.label, row),
                            'animate-point',
                            getCompleteIncompleteClass(stage)
                          ]"
                          [style.animationDelay]="i * 1.2 + 's'"
                        ></div>
                        <div
                          *ngIf="i < row.statusesStages.length - 1"
                          class="timeline-line animate-line"
                          [ngClass]="[
                            getStageColorClass(stage.label, row),
                            getCompleteIncompleteClass(stage)
                          ]"
                          [style.animationDelay]="i * 1.2 + 0.6 + 's'"
                        ></div>
                      </div>
                    </div>
                  </div>
                  <div class="timeline-box-header">
                    <div
                      class="timeline-box-in"
                      *ngFor="let stage of row.statusesStages"
                    >
                      <div class="timeline-stage-header">
                        <div class="stage-header-up">
                          <!-- <span class="stage-heading">{{ stage.heading }}</span> -->
                          <span class="stage-date">{{ stage.date }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ng-template>
        </ngx-datatable-column>

        <!-- select rfq -->
        <ngx-datatable-column
          [sortable]="false"
          [maxWidth]="55"
          [minWidth]="55"
        >
          <ng-template ngx-datatable-header-template>
            <input
              type="checkbox"
              [checked]="this.selectedRfq.length == this.documentData.length"
              (change)="toggleSelectAll($event, 'active')"
            />
          </ng-template>
          <ng-template let-row="row" ngx-datatable-cell-template>
            <!-- <input type="checkbox" [checked]="isChecked(row.rfqId,'active')"
                        (change)="selectDeselectRfq($event, row.rfqId,'active',row.owner)" /> -->
            <input
              type="checkbox"
              [checked]="isChecked(row.quoteId, 'active')"
              (change)="
                selectDeselectRfq(
                  $event,
                  row.supplierRfqDetailsId,
                  row.quoteId,
                  'active',
                  row.supplierUserName
                )
              "
            />
          </ng-template>
        </ngx-datatable-column>
      </ngx-datatable>
    </div>

    <div class="archive-container" #heading>
      <span
        style="
          padding-left: 16px;
          padding-top: 16px;
          margin-bottom: 20px;
          font-weight: bold;
          display: flex;
          justify-content: space-between;
          padding-right: 20px;
        "
        (click)="toggleArchived()"
      >
        <div style="display: inline-flex; align-items: center">
          <span style="margin-left: 4px">Archived Documents</span>
        </div>

        <mat-icon>
          {{ isArchivedExpand ? "expand_less" : "expand_more" }}
        </mat-icon>
      </span>

      <ng-container *ngIf="isArchivedExpand">
        <div
          class="filter-section-selection-container"
          style="display: flex; align-items: center"
          *ngIf="this.selectedArchivedRfq.length > 0"
        >
          <div style="margin-left: 10px">
            <b
              >Selected {{ this.selectedArchivedRfq.length }} of
              {{ this.archivedTotalRecords }} archived Quotes</b
            >
          </div>

          <button
            style="position: relative; bottom: 3px"
            mat-icon-button
            mat-sm-button
            color="primary"
            class="mr-1"
            matTooltipClass="mat-tooltip-custom"
            matTooltip="Urchive"
            matTooltipPosition="below"
            (click)="rfqOperation('unarchive')"
          >
            <mat-icon>unarchive</mat-icon>
          </button>
        </div>
        <div class="dropdown-container">
          <button
            mat-fab
            class="green-button"
            [matMenuTriggerFor]="menu"
            matTooltip="Show more columns"
          >
            <mat-icon style="position: relative; right: -3px"
              >playlist_add</mat-icon
            >
          </button>
          <mat-menu #menu="matMenu">
            <button
              mat-menu-item
              *ngFor="let item of archivedItems"
              (click)="archivedToggleSelection(item)"
            >
              <mat-checkbox [checked]="item.selected">{{
                item.label
              }}</mat-checkbox>
            </button>
          </mat-menu>
        </div>
        <ngx-datatable
          #archivedSection
          #supplierTable
          class="material expandable bg-light supplier-table sup-tbl"
          [rows]="archivedDocumentData"
          [rowIdentity]="rowIdentity"
          [headerHeight]="50"
          [footerHeight]="50"
          [rowHeight]="'auto'"
          [columnMode]="'force'"
          [limit]="limit"
          [count]="archivedTotalRecords"
          [externalPaging]="true"
          [externalSorting]="true"
          [scrollbarH]="false"
          [offset]="archivedOffset"
          (page)="onArchivedPageChange($event)"
          (sort)="onSort($event)"
          [rowClass]="setRowClass"
        >
          <ngx-datatable-column name="Quote Reference" [flexGrow]="1">
            <ng-template let-row="row" ngx-datatable-cell-template>
              <span
                class="rfq-reference"
                matTooltip="{{ row.quoteRefNumber }}"
                matTooltipPosition="below"
                (click)="openQuoteDetails(row.rfqDetailsId, row.quoteId)"
                >{{ row.quoteRefNumber }}</span
              >
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column name="RFQ Reference" [flexGrow]="1">
            <ng-template let-row="row" ngx-datatable-cell-template>
              <span
                class="rfq-reference"
                matTooltip="{{ row.rfqRefNumber }}"
                matTooltipPosition="below"
                (click)="openRfqDetails(row.rfqDetailsId)"
                >{{ row.rfqRefNumber }}</span
              >
            </ng-template>
          </ngx-datatable-column>
          <!-- vessel Name -->
          <!-- <ngx-datatable-column name="Vessel" [flexGrow]="1">
        <ng-template let-row="row" ngx-datatable-cell-template>
          <span
            class="Vessel"
            matTooltip="{{ row.vesselName }}"
            matTooltipPosition="below"
            >{{ row.vesselName }}</span
          >
        </ng-template>
      </ngx-datatable-column> -->
          <!-- Port Name -->
          <ngx-datatable-column name="Port Name" [flexGrow]="1">
            <ng-template let-row="row" ngx-datatable-cell-template>
              <span
                class="Port Name"
                matTooltip="{{ row.portName }}"
                matTooltipPosition="below"
                >{{ row.portName }}</span
              >
            </ng-template>
          </ngx-datatable-column>

          <!-- Buyer with Logo -->
          <ngx-datatable-column name="Buyer" [flexGrow]="1">
            <ng-template let-row="row" ngx-datatable-cell-template>
              <div class="buyer-cell">
                <img
                  [src]="row.organizationLogo"
                  class="buyer-logo"
                  alt="logo"
                />
                <span
                  matTooltip="{{ row.companyName }}"
                  matTooltipPosition="below"
                  >{{ row.companyName }}</span
                >
              </div>
            </ng-template>
          </ngx-datatable-column>
          <!-- Remaining time -->

          <!-- Quotation Date -->
          <!-- <ngx-datatable-column name="Quotation Date" [flexGrow]="1">
                <ng-template let-row="row" ngx-datatable-cell-template>
                <span matTooltip="{{ row.quotedByDate | date:'dd/MM/yyyy' }}" matTooltipPosition="below">{{ row.quotedByDate | date:'dd/MM/yyyy' }}</span>
                </ng-template>
            </ngx-datatable-column> -->

          <!-- Owner -->
          <!-- <ngx-datatable-column name="Owner" [flexGrow]="1">
                <ng-template let-row="row" ngx-datatable-cell-template>
                <span matTooltip="{{ row.owner }}" matTooltipPosition="below">{{ row.owner }}</span>
                </ng-template>
            </ngx-datatable-column> -->
          <ngx-datatable-column name="Owner" [flexGrow]="1">
            <ng-template let-row="row" ngx-datatable-cell-template>
              <span
                matTooltip="{{
                  row.supplierUserName ? row.supplierUserName : row.supplierName
                }}"
                matTooltipPosition="below"
              >
                {{ row.supplierUserName || row.supplierName }}
              </span>
            </ng-template>
          </ngx-datatable-column>

          <!-- Status -->
          <ngx-datatable-column name="Status" [minWidth]="150" [flexGrow]="1">
            <ng-template let-row="row" ngx-datatable-cell-template>
              <span
                class="status-pill"
                matTooltip="{{ quoteStatuses[row.quoteStatus - 1] }}"
                matTooltipPosition="below"
                [ngStyle]="{
                  color: getStatusColor(quoteStatuses[row.quoteStatus - 1])
                }"
              >
                {{ quoteStatuses[row.quoteStatus - 1] }}
              </span>
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column name="Quotation Submission Date" [flexGrow]="1">
            <ng-template let-row="row" ngx-datatable-cell-template>
              <span
                class="RFQ Date"
                matTooltip="{{ row.quotationDate | date : 'dd/MM/yyyy' }}"
                matTooltipPosition="below"
              >
                {{ formatRfqDate(row.quotationDate) }}
              </span>
            </ng-template>
          </ngx-datatable-column>

          <!-- <ngx-datatable-column name="Quote Before Date" [flexGrow]="1">
        <ng-template let-row="row" ngx-datatable-cell-template>
          <span
            class="Quote Before Date"
            matTooltip="{{ getRemainingTimeForQuoteDate(row).tooltip }}"
            matTooltipPosition="below"
          >
            {{ row.quotedByDate | date : "dd/MM/yyyy" }}
          </span>
        </ng-template>
      </ngx-datatable-column> -->

          <ngx-datatable-column
            *ngFor="let column of archivedSelectedColumns"
            [name]="column.label"
            [flexGrow]="1"
          >
            <ng-template let-row="row" ngx-datatable-cell-template>
              <span
                *ngIf="isDate(row[column.prop])"
                matTooltip="{{ row[column.prop] | date : 'dd/MM/yyyy' : '-' }}"
                matTooltipPosition="below"
              >
                {{ row[column.prop] | date : "dd/MM/yyyy" : "-" }}
              </span>
              <span
                *ngIf="!isDate(row[column.prop])"
                matTooltip="{{ row[column.prop] || '-' }}"
                matTooltipPosition="below"
              >
                {{ row[column.prop] || "-" }}
              </span>
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column
            name="Action"
            [flexGrow]="1"
            [resizeable]="true"
          >
            <ng-template let-column="column" ngx-datatable-header-template>
              <span class="bold-header">Action</span>
            </ng-template>
            <ng-template let-row="row" ngx-datatable-cell-template>
              <button
                [mdePopoverTriggerFor]="appPopover"
                mdePopoverTriggerOn="click"
                [mdePopoverBackdropCloseOnClick]="false"
                mat-icon-button
                matTooltip="Restore Quote"
                #popoverTrigger="mdePopoverTrigger"
              >
                <mat-icon style="color: #f99c30"> restore </mat-icon>
              </button>
              <mde-popover
                #appPopover="mdePopover"
                [mdePopoverOverlapTrigger]="false"
              >
                <mat-card class="mat-card-popover">
                  <mat-card-header class="mat-card-header-popover">
                    <mat-card-title>Are you sure?</mat-card-title>
                  </mat-card-header>

                  <mat-card-actions
                    class="mat-card-action-popover display-flex justify-content-space-between"
                    style="gap: 10px"
                  >
                    <button
                      class="mat-action-btn popover_action cancel"
                      mat-raised-button
                    >
                      Cancel
                    </button>
                    <button
                      class="mat-action-btn popover_action"
                      (click)="restore(row.quoteId, 'unArchive')"
                      mat-raised-button
                      color="warn"
                    >
                      Restore
                    </button>
                  </mat-card-actions>
                </mat-card>
              </mde-popover>
            </ng-template>
          </ngx-datatable-column>

          <!-- select rfq -->
          <ngx-datatable-column
            [sortable]="false"
            [maxWidth]="55"
            [minWidth]="55"
          >
            <ng-template ngx-datatable-header-template>
              <input
                type="checkbox"
                [checked]="this.selectedRfq.length == this.documentData.length"
                (change)="toggleSelectAll($event, 'inactive')"
              />
            </ng-template>
            <ng-template let-row="row" ngx-datatable-cell-template>
              <!-- <input type="checkbox" [checked]="isChecked(row.rfqId,'active')"
                        (change)="selectDeselectRfq($event, row.rfqId,'active',row.owner)" /> -->
              <input
                type="checkbox"
                [checked]="isChecked(row.quoteId, 'inactive')"
                (change)="
                  selectDeselectRfq(
                    $event,
                    row.supplierRfqDetailsId,
                    row.quoteId,
                    'inactive',
                    row.supplierUserName
                  )
                "
              />
            </ng-template>
          </ngx-datatable-column>
        </ngx-datatable>
      </ng-container>
    </div>
  </div>
</div>


<app-contact-details
  [showContactPopup]="showContactPopup"
  [contactData]="selectedBuyer"
  (close)="showContactPopup = false">
</app-contact-details>


<app-document-preview
  [previewDocs]="previewDocs"
  [showPopup]="previewSection"
  (close)="previewSection = false">
</app-document-preview>
